export function copyValue(target, src) {
    for (let prop in target){
        if(src.hasOwnProperty(prop)){
            target[prop] = src[prop];
        }
    }
}

/**
 * 将 Date 转化为指定格式的String
 * 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
 * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 * DateFormat(new Date() ,"yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
 * DateFormat(new Date(), "yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
 * @param date 需要转换的日期
 * @param fmt
 * @return {*}
 * @constructor
 */
export function DateFormat(date, fmt = 'yyyy-MM-dd hh:mm:ss') {
    let o = {
        "M+": date.getMonth() + 1,                 //月份
        "d+": date.getDate(),                    //日
        "h+": date.getHours(),                   //小时
        "m+": date.getMinutes(),                 //分
        "s+": date.getSeconds(),                 //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds()             //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (let k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

/**
 * dataURL转换为Bold对象
 * @param dataurl base64格式
 * @returns {Blob}
 */
export function dataURItoBlob(dataurl){   //dataurl是base64格式
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {type:mime});
}

/**
 * 读取input 文件内容
 * @param input
 * @returns {Promise<unknown>}
 */
function readInput(input) {
    return new Promise((resolve, reject) => {
        //支持chrome IE10
        if (window.FileReader) {
            let file = input.files[0];
            // let filename = file.name.split(".")[0];
            let reader = new FileReader();
            reader.onload = function () {
                console.log(this.result);
                resolve(this.result);
            }
            reader.readAsText(file);
        }
        //支持IE 7 8 9 10
        else if (typeof window.ActiveXObject != 'undefined') {
            let xmlDoc;
            xmlDoc = new ActiveXObject("Microsoft.XMLDOM");
            xmlDoc.async = false;
            xmlDoc.load(input.value);
            console.log(xmlDoc.xml);
            resolve(xmlDoc.xml)
        }
        //支持FF
        else if (document.implementation && document.implementation.createDocument) {
            let xmlDoc;
            xmlDoc = document.implementation.createDocument("", "", null);
            xmlDoc.async = false;
            xmlDoc.load(input.value);
            console.log(xmlDoc.xml);
            resolve(xmlDoc.xml)
        } else {
            // alert('error');
            reject('浏览器不支持！')
        }
    })
}

/**
 * 上传图片
 * @param vueApp 传vue中this对象
 * @param base64 图片base64
 * @param fileName 文件名
 * @param maxImgW 最大宽度 默认1024，0：不限制
 * @param maxImgH 最大高度 默认1024, 0：不限制
 * @param quality 图片质量，默认 0.85
 */
export function uploadImageByBase64(vueApp, base64, fileName, maxImgW = 1024, maxImgH = 1024, quality = 0.85) {
    return new Promise((resolve, reject) => {
        resizeImageToBase64(base64, maxImgW, maxImgH, quality).then(resizeBase64 => {
            let blob = dataURItoBlob(resizeBase64);
            let formData = new FormData();
            formData.append("file", blob, fileName);
            vueApp.$filePost('/upload', formData, 3).then(res => {
                console.log(res)
                res.data.base64 = resizeBase64;
                resolve(res)
            }).catch(err=>{
                reject(err);
            })
        });
    })
}

// export function uploadImageByFile(vueApp, file, maxImgW = 1024, maxImgH = 1024, quality = 0.85){
//
// }

/**
 * 压缩图片大小，
 * @param imageData Base64数据
 * @param maxImgW 最大宽度 默认1024，0：不限制
 * @param maxImgH 最大高度 默认1024, 0：不限制
 * @param quality 图片质量，默认 0.85
 * @returns {Promise<String>} 返回图片Base64
 */
export function resizeImageToBase64(imageData, maxImgW = 1024, maxImgH = 1024, quality = 0.85) {
    return new Promise((resolve) => {
        // maxImgW 和 maxImgH 均是0时，不做处理
        if(maxImgH || maxImgW){
            let image = new Image();
            image.onload = function () {
                let canvas = document.createElement('canvas')
                let imageWidth = image.width;
                let imageHeight = image.height;
                if (image.width > maxImgW) {
                    imageWidth = maxImgW;
                    imageHeight = image.height * (maxImgW / image.width);
                }
                if (imageHeight > maxImgH) {
                    imageWidth = image.width * (maxImgH / image.height);
                    imageHeight = maxImgH;
                }
                canvas.width = imageWidth;
                canvas.height = imageHeight;
                let con = canvas.getContext('2d');
                con.clearRect(0, 0, canvas.width, canvas.height);
                con.drawImage(image, 0, 0, imageWidth, imageHeight);
                let base64 = canvas.toDataURL('image/jpeg', quality);
                resolve(base64);
            }
            //image.src="data:application/octet-stream;"+imageData.substr(imageData.indexOf("base64,"));
            // image.src = "data:image/jpeg;base64," + imageData;
            image.src = imageData;
        }else {
            resolve(imageData);
        }
    });
}


export function payText(is_paid) {
    //
    return is_paid ? '已支付' : '未支付'
}

const rentalStatusTexts = ['未租', '新租', '月租', '退租']
export function rentalStatus(status) {
//状态，0未租，1新租，2续费，3退租
    return rentalStatusTexts[Number(status)];
}

/**
 * 返回0时区的 1970 年 1 月 1 日至今的毫秒数
 * @param dateStr 日期字段串，如2020-02 或 2020-02-03
 * @returns {number} 返回0时区的 1970 年 1 月 1 日至今的毫秒数
 */
export function DateStrToTime(dateStr) {
    let date = new Date(dateStr);
    return date.getTime() + (date.getTimezoneOffset() * 60000);
}

/**
 *
 * @param {Vue} thisApp
 * @param {String} path
 * @param {Object} params
 * @param {boolean} isReplace
 */
export function goRouterPage(thisApp, path, params = null, isReplace = false) {
    if (isReplace) {
        thisApp.$router.replace({path: path, query: params});
    } else {
        thisApp.$router.push({path: path, query: params});
    }

    // thisApp.$router.push("/")
}
export function goPage(url, isRedirect = false) {
    if (isRedirect) {
        // self.location.href = url;
        window.location.replace(url);
    } else {
        window.location.href = url;
    }
}

/**
 * 将 Date 转化为指定格式的String
 * FormatDate(new Date(), "yyyy-MM-dd HH:mm:ss.S") ==> 2006-07-02 08:09:04.423
 * FormatDate(new Date(), "yyyy-M-d H:m:s.S")      ==> 2006-7-2 8:9:4.18
 * @param date {Date}
 * @param fmt {string} 月(M)、日(d)、小时(H)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符， 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 * @returns {string}
 * @constructor
 */
export function FormatDate(date, fmt) {
    const o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
    }
    for (let k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length == 1
                    ? o[k]
                    : ("00" + o[k]).substr(("" + o[k]).length)
            );
        }
    }
    return fmt;
}